import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { StatModule } from '@app/shared/modules/stat/stat.module';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './pages/dashboard.component';
import { SharedModule } from '@app/shared/shared.module';
import { DashboardReportsComponent } from './components/dashboard-reports/dashboard-reports.component';
@NgModule({
  imports: [CommonModule, SharedModule, DashboardRoutingModule, StatModule, DashboardReportsComponent],
  declarations: [
    DashboardComponent //dashboard cards [5 cards]
  ],
  exports: [DashboardComponent]
})
export class DashboardModule {}
